//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import { mapActions } from "vuex";
import { APP_DATE_SLASH } from "@/assets/js/appConfig";
import { date } from "quasar";
import { formatDateAndTime } from "@/components/Diagrams/config/set-conditions";

export default {
    components: {
        AQModal,
        AQRadio,
        AQInput,
        AQDropdown,
        AQCard
    },
    props: {
        deletion: {
            type: Boolean,
            default: false
        },
        period: {
            type: Number,
            default: 6
        },
        timeUnit: {
            type: String,
            default: "M"
        },
        deletionDate: {
            type: String,
            default: ""
        },
        indefinite: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showModal: true,
            retentionType: this.indefinite ? "INDEFINITE" : "LIMITED",
            periodModal: this.period,
            periodError: false,
            periodErrorMsg: this.$t("processes.emptyPeriod"),
            dateErrorMsg: this.$t("admin.processInspector.invalidRetentionDate"),
            checkPeriod: false,
            deletionDateModal: this.deletionDate || this.deletionDateFormat(),
            timeUnitModal: [{ value: this.timeUnit }],
            periodValues: [
                { label: this.$t("apps.days"), value: "D" },
                { label: this.$t("apps.weeks"), value: "W" },
                { label: this.$t("apps.months"), value: "M" },
                { label: this.$t("apps.years"), value: "Y" }
            ]
        };
    },
    computed: {
        saveBtn() {
            return { label: this.$t("generic.save"), disabled: this.checkBtnState };
        },
        checkBtnState() {
            let stateToReturn = false;
            if (!this.deletion) {
                stateToReturn = this.checkPeriod && this.retentionType === "LIMITED";
            } else if (!this.deletionDateModal && this.retentionType === "LIMITED") {
                stateToReturn = true;
            }
            return stateToReturn;
        }
    },
    methods: {
        ...mapActions("admin", ["actSaveRetention", "actSaveDeletion"]),
        deletionDateFormat() {
            const currentDate = new Date();
            return formatDateAndTime("datetime", new Date(currentDate.setMonth(currentDate.getMonth() + 6)), false).replace(/'/g, "");
        },
        actionsDlg($event) {
            if ($event === "save") {
                if (this.deletion) {
                    const payload = this.retentionType === "INDEFINITE" ? null : this.deletionDateModal.split("+")[0];
                    this.actSaveDeletion(payload).then(data => {
                        if (data) {
                            this.$root.$emit("savedDeletion", { deletionDate: payload, type: this.retentionType });
                        }
                    });
                } else {
                    const payload = {
                        period: this.retentionType === "INDEFINITE" ? null : `P${this.periodModal}${this.timeUnitModal[0].value}`,
                        type: this.retentionType
                    };
                    this.actSaveRetention(payload).then(data => {
                        if (data) {
                            this.$root.$emit("savedRetention", { period: this.periodModal, unit: this.timeUnitModal[0].value, type: this.retentionType });
                        }
                    });
                }
                this.$emit("input", false);
            } else if ($event === "close") {
                this.showModal = false;
                this.$emit("input", false);
            }
        },
        changePeriod(period) {
            const regex = /^(0|[1-9][0-9]*)$/;
            this.checkPeriod = !period || !regex.test(period);
        },
        startDateOptions(startingDate) {
            return startingDate > date.formatDate(new Date(), APP_DATE_SLASH);
        }
    }
};
